import styled from 'styled-components';

export const PageError = styled.div`
  text-align: center;
  margin: 100px 0;
`;
